// @flow

import React, { type Node } from 'react';
import { getBoletoBarcodeRaw, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import Barcode from 'react-barcode';
import styled from 'styled-components';

export function BoletoBarcode(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <BarcodeWrapper data-test-id="boleto-barcode">
      <Barcode
        format="ITF"
        value={getBoletoBarcodeRaw(incomingPayment)}
        displayValue={false}
        width={2}
        height={60}
        margin={0}
        textMargin={0}
      />
    </BarcodeWrapper>
  );
}


const BarcodeWrapper = styled.div`
  max-width: 480px;
  svg {
    width: 100%;
    display: none;
    margin-bottom: 20px;
  }
  @media (min-width: 840px) {
      svg {display: block;}
  }
`;
